var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bottom-dialog',{attrs:{"title":"チャット設定","container":false,"value":_vm.value},on:{"input":_vm.onInput}},[_c('chat-configuration-tabs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }